import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Icon } from 'semantic-ui-react'
import { Pagination, SortIcon } from '../components'

const { Header, Body, Row, Cell, HeaderCell, Footer } = Table

const sortIcons = {
  ascending: <SortIcon ascending />,
  descending: <SortIcon descending />,
  sort: <SortIcon />,
}

const getLocationsActive = (result) => {
  if (!result.archivedAt) {
    return <Icon name="checkmark" color="green" size="large" />
  } else {
    return <Icon name="remove" color="red" size="large" />
  }
}

const LocationsTable = ({
  locations, meta, list, waitingForDownload, getCSV, csv, clearDownload,
}) => {
  const paging = list.$paging(meta.count)
  return (
    <Table className="locations">
      <Header>
        <Row>
          <HeaderCell />
          <HeaderCell>{list.$heading('nameSort', 'Název lokace', sortIcons)}</HeaderCell>
          <HeaderCell />
        </Row>
      </Header>
      <Body>
        {locations.map((l) => (
          <Row key={l._id}>
            <Cell className="cell-with-icon">{getLocationsActive(l)}</Cell>
            <Cell>{l.name}</Cell>
            <Cell><Link to={`/locations/${l._id}`}><i className="daicon daicon-Edit" /> Upravit</Link></Cell>
          </Row>
        ))}
      </Body>
      <Footer>
        <Row>
		  <Cell></Cell>
          <Cell>
            {`
              Zobrazeno
              ${Math.min(((meta.currentPage - 1) * 100) + 1, meta.count)}
              -
              ${Math.min((meta.currentPage * 100) + 1, meta.count)} z ${meta.count}
            `}
            {(getCSV || csv) && <span>-&nbsp;</span>}
            {getCSV && !csv &&
              <span className="downloadCSV">
                {waitingForDownload
                  ? <Icon loading name="spinner" />
                  : <a onClick={getCSV}>Stáhnout CSV</a>
                }
              </span>
            }
            {csv &&
              <a href={csv} rel="noopener noreferrer" target="_blank" onClick={clearDownload}>
                CSV připraveno, klikněte pro stažení
              </a>
            }
          </Cell>
          <Cell><Pagination paging={paging} /></Cell>
        </Row>
      </Footer>
    </Table>
  )
}

LocationsTable.defaultProps = {
  getCSV: null,
  waitingForDownload: false,
  csv: '',
}

LocationsTable.propTypes = {
  locations: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  list: React.PropTypes.object.isRequired,
  getCSV: React.PropTypes.any,
  waitingForDownload: React.PropTypes.bool,
  clearDownload: React.PropTypes.func.isRequired,
  csv: React.PropTypes.string,
}

export default LocationsTable



// WEBPACK FOOTER //
// ./src/browser/tables/Locations.js